import Icons, { IconsProps } from '../Icons';

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7769 4.63306L22.7361 12L14.7769 19.3669L14.0976 18.6331L20.7237 12.5H2V11.5H20.7237L14.0976 5.36694L14.7769 4.63306Z"
        />
      </svg>
    </Icons>
  );
}
